module.exports = __webpack_public_path__ + "assets/img/28.f6b41dfc.png";